import { inject } from '@angular/core';
import { HttpEventType, HttpInterceptorFn, HttpResponse } from '@angular/common/http';
import { KeycloakService } from './keycloak.service';
import { tap } from 'rxjs';

export const webApiInterceptor: HttpInterceptorFn = (req, next) => {
  const token = inject(KeycloakService).bearerToken();

  console.log('API request ', req.method, req.url);
  if (token) {
    req = req.clone({
      headers: req.headers.set('Authorization', `Bearer ${ token }`)
    });
  }

  return next(req).pipe(
    tap({
      next: (res) => {
        if (res.type === HttpEventType.Response) {
          const httpResponse = res as HttpResponse<object>;
          console.log('API response ', req.method, req.url, httpResponse.body);
        }
      },
      error: (error) => {
        console.error('API request ', req.method, req.url, ' failed with error:', error);
      },
    })
  );
};
